
import {
    mdiAlert,
    mdiAlertCircle,
    mdiAutorenew,
    mdiCheck,
    mdiSend,
} from "@mdi/js"

export default {
    name: "SendButton",
    model: {
        prop: "state",
        event: "click",
    },
    props: {
        /** Sets the current state. Refer to state-mapping for valid values. (Optional: Boolean) */
        state: {
            default: "unsent",
        },
        /** Activates tooltip with error message provided */
        error: {
            type: String,
            default: "",
        },
        /** Duration how long the error message should be displayed */
        errorDuration: {
            default: 7,
        },
        /** Classes that get applied to the visible button */
        buttonClass: {
            type: String,
            default: "",
        },
        /** Sets the button to fab */
        fab: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            /** Use these keys as states in prop */
            statemapper: {
                unsent: { icon: mdiSend, color: "#fff" },
                pending: { icon: mdiAutorenew, color: "#fff" },
                success: { icon: mdiCheck, color: "##fff" },
                warning: { icon: mdiAlert, color: "#F6A825" },
                error: { icon: mdiAlertCircle, color: "#DB4436" },
            },
            tooltip: false,
        }
    },
    computed: {
        internalState() {
            if (typeof this.state == "boolean") {
                return this.state ? "unsent" : "success"
            }
            if (this.statemapper[this.state]) {
                return this.state
            }
            return "warning"
        },
    },
    watch: {
        error: function (val) {
            if (val !== "") {
                this.tooltip = true
                setTimeout(
                    () => (this.tooltip = false),
                    Number(this.errorDuration) * 1000
                )
            }
        },
    },
}
